import {AuthUser, AuthSubscription} from "../../Models/DTOs/AuthUser";

function normStatus(sub?: AuthSubscription | null): string | null {
    return (sub?.status ?? null)?.toLowerCase() ?? null;
}

// --- Auth checks ------------------------------------------------------------

export function IsAuthenticated(authUser?: AuthUser | null): boolean {
    // If you store the JWT elsewhere, you can wire that here.
    // For app logic, a present, verified user id is sufficient.
    return !!authUser?.id;
}

export function IsActive(authUser?: AuthUser | null): boolean {
    // Legacy special-case (AccessLevel === 99) doesn’t exist anymore.
    // If you still need a “superuser is always active” rule, key it off roles:
    // if (authUser?.roles?.includes("superuser")) return true;

    const s = normStatus(authUser?.subscription);
    // Match previous behavior: Active, Trialing, and Canceled (access until period end) are "active".
    return s === "active" || s === "trialing" || s === "canceled";
}

export function NeedsRenew(authUser?: AuthUser | null): boolean {
    const s = normStatus(authUser?.subscription);
    return s === "past_due" || s === "unpaid" || s === "incomplete";
}
